import { NgModule } from "@angular/core";
import { SyncFilesComponent } from "./sync-files.component";
import { TranslateModule } from "@ngx-translate/core";
import { BzgButtonModule, BzgModalModule } from "bz-genome-angular";
import { CommonModule } from "@angular/common";
import { SharedModule } from "app/shared/shared.module";
import { ImportSyncFilesComponent } from './import-sync-files/import-sync-files.component';
import { ImportSyncFilesModalComponent } from './import-sync-files/import-sync-files-modal/import-sync-files-modal.component';
import { SyncFilesErrorTableComponent } from './sync-files-error-table/sync-files-error-table.component';
import { ExportSyncFilesComponent } from "./export-sync-files/export-sync-files.component";
import { SyncFilesHistoryComponent } from './sync-files-history/sync-files-history.component';

const customGenomeConfiguration = {
  'icons-sprite-path': 'assets/sprite.svg',
  'color-text-primary': '#555555',
  'color-text-secondary': '#B7B7B7',
  'color-button-primary': '#3e5c72',
  'color-button-secondary': 'transparent',
  'color-header-primary': '#4285f4',
  'color-header-secondary': '#4285f4',
  'color-header-fill': '#ffffff',
  'color-icon-header-primary': '#0039cb',
  'color-icon-header-secondary': '#0039cb',
  'color-icon-header-fill': '#ffffff',
  'color-user-info': '#ffffff',
  'color-avatar': '#dadeda',
  'color-avatar-background': '#ffffff'
};


@NgModule({
  declarations: [
    SyncFilesComponent,
    ExportSyncFilesComponent,
    ImportSyncFilesComponent,
    ImportSyncFilesModalComponent,
    SyncFilesErrorTableComponent,
    SyncFilesHistoryComponent
  ],
  imports: [
    CommonModule,
    BzgButtonModule,
    TranslateModule,
    BzgModalModule,
    SharedModule
  ]
})
export class SyncFilesModule { }
